<template>
	<div>
		<div class="employments">
			<employment-view :open="i == value.length - 1" v-for="(e, i) in value" :key="i" :value="e" @input="(value) => { updateEmployment(i, value) }" @remove="remove(i)" />
		</div>
		<div class="btn" @click="add">Tilføj ansættelse</div>
	</div>
</template>

<script>
	import EmploymentView from './EmploymentView';

	export default {
		components: {
			EmploymentView,
		},
		props: {
			value: {
				type: Array,
				required: true,
			}
		},
		methods: {
			add() {
				let value = Array.from(this.value);
				
				value.push({
					from: null,
					to: null
				});

				this.$emit('input', value);
			},
			remove(index) {
				console.log(index);
				let value = Array.from(this.value);

				value.splice(index, 1);

				this.$emit('input', value);
			},
			updateEmployment(index, value) {
				let employments = Array.from(this.value);

				employments[index] = value;

				this.$emit('input', employments);
			}
		}
	}
</script>

<style lang="scss" scoped>


	.btn {
		background-color: #202127;
		line-height: 40px;
		text-align: center;
		margin-bottom: 10px;
		cursor: pointer;
	}
</style>